import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-form-create',
  templateUrl: './base-form-create.component.html',
  styleUrl: './base-form-create.component.scss'
})
export class BaseFormCreateComponent<T> implements OnInit {
  formComponentInstance

  @Input() id: string
  @Input() data: {}
  @Input() set formComponent(_formComponent) {
    if (!_formComponent) return;
    this.formComponentInstance = _formComponent;
  }
  ngOnInit(): void {

  }
}
